import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { roleDestination } from "@/auth/roleDestination";

export default function ProtectedRoute({ allow = ["master", "admin", "pt"], children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="loading-screen" data-testid="protected-route-loading">Memuat…</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (!allow.includes(user.role)) {
    return <Navigate to={roleDestination(user.role)} replace />;
  }
  return children;
}
